import { Panel } from "primereact/panel";
import CmsService from "../../../service/CmsService";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import Croppr from "croppr";
import 'croppr/dist/croppr.css';
import { useTranslation } from "react-i18next";

export function CropImage({id,onChange})
{
    const {t}=useTranslation();
    const [page,setPage] = useState(1);

    const onPrev=()=>{
        if(page>1)
            setPage(page-1);
    }
    const onNext=()=>{
        setPage(page+1);
    }
    useEffect(()=>{
    },[])
    const headerTemplate=()=>{
        return(
            <div className="flex justify-content-between flex-wrap p-toolbar gap-2">
                <div className="flex gap-2"><label>{t('Page')+': '+page}</label></div>
                <div className="flex gap-2">
                    <Button label={t('crop.Prev_page')} onClick={onPrev}/>
                    <Button label={t('crop.Next_page')} onClick={onNext}/>
                </div>
            </div>
        );
    }
    const onCropChange=(data)=>{
        onChange({...data,page:page});
    }
    return(
        <>
        <Panel headerTemplate={headerTemplate}>
            <div className="overflow-auto">
                <CropprReact key={'/procs/'+id+'/image?page='+page} procId={id} page={page} onChange={onCropChange}/>
            </div>
        </Panel>
        </>
    );
}

export function CropprReact({procId,page,onChange}){
    const imgRef = useRef(null);
    const [src,setSrc] = useState('');
    var croppr=null;

    const loadImg=()=>{
        CmsService.getSourceImage(procId,page).then((ret)=>{
            const objectUrl = URL.createObjectURL(ret);
            setSrc(objectUrl);            
        });
    }
    const createCroppr=()=>{
        croppr = new Croppr(imgRef.current, {
            // custom aspect radio
            // e.g.
            aspectRatio: null,
            // min/max sizes
            maxSize: { width: 600, height: 1024, unit: 'px' },
            minSize: { width: 10, height: 10, unit:'px' },
            // start size of crop region
            startSize: { width: 50, height: 50, unit: 'px' },
            // real", "ratio" or "raw"
            returnMode: 'real',
            // callback functions
            onCropStart: onCropChange,
            onCropMove: onCropChange,
            onCropEnd: onCropChange,
            onInitialize: function(instance) {
                instance.moveTo(100,100);
                instance.resizeTo(100,100);
                //if(reportId>0)
                //    $('#imageContainer').show();
            }
            
        });
        console.log("cropper constructed");
    }
    useEffect(()=>{
        console.log("Croppr.initializing:"+src);
        loadImg();

        return () => {
            console.log("Component is unmounting. Cleaning up resources...");
            if(croppr) 
                croppr.destroy();
            if(imgRef.current)
                imgRef.current=null;
        };
    },[]);
    useEffect(()=>{        
        if (!imgRef.current) return;
        if(croppr==null && src>'')
            createCroppr();
    },[src]);
    const onCropChange=(data)=>{
        if(onChange)
            onChange(data);
    }
    return(
        <div id="cropprContainer">
            <img id="croppr" ref={imgRef} src={src}></img>
        </div>
    );
}